import Head from "next/head";
import React from "react";

import SignUpMain from "@/components/auth/sign-up";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function SignUp() {
  return (
    <>
      <Head>
        <title>{seoData.REGISTER.title}</title>
        <SeoMetaData data={seoData.REGISTER} />
      </Head>

      <SignUpMain />
    </>
  );
}
